import NavigationNode from '../navigation-node/navigation-node.vue';
import { createNamespacedHelpers } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';
import NavigationFilters from '../navigation-filters/navigation-filters.vue';
import { mixin as clickaway } from 'vue-clickaway';
import sidebarMutations from '@/store/global/mutation-types';
import FilteredNavigationItems from '../filtered-navigation-items/filtered-items.vue';

const { mapState: mapSidebarState, mapMutations: mapSidebarMutations } = createNamespacedHelpers('global');
const { mapState: mapNavigationState } = createNamespacedHelpers('navigation');
const { mapGetters: mapVersionGetters, mapState: mapVersionState } = createNamespacedHelpers('versions');

@Component({
    components: {
        'navigation-node': NavigationNode,
        'navigation-filters': NavigationFilters,
        'filtered-navigation-items': FilteredNavigationItems
    },

    computed: {
        ...mapSidebarState(['isMobileVisible']),
        ...mapNavigationState(['navigationTree', 'navigationData', 'filter']),
        ...mapVersionState(['versions']),
        ...mapVersionGetters({
            currentVersion: 'getCurrentVersionLabel'
        }),
        inNavigationFiltered() {
            return this.filter.length;
        }
    },

    mixins: [clickaway],

    methods: {
        ...mapSidebarMutations({
            toggleSidebar: sidebarMutations.TOGGLE_SIDEBAR_VISIBILITY
        }),

        handleClickAway(evt) {
            if (this.isMobileVisible && !evt.target.closest('.js__show-sidebar-menu')) {
                this.toggleSidebar();
            }
        }
    }
})
export default class Navigation extends Vue {}
